import { render, staticRenderFns } from "./CursoEdit.vue?vue&type=template&id=ddfc0406&"
import script from "./CursoEdit.vue?vue&type=script&lang=js&"
export * from "./CursoEdit.vue?vue&type=script&lang=js&"
import style0 from "./CursoEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports